module.exports = __webpack_public_path__ + "static/media/Compact_Comfortable.528326ff.svg";